import differenceInMinutes from 'date-fns/difference_in_minutes'

const shifts = () => {
  'ngInject'

  const calcTotalHours = (start, end, lunchDuration) => {
    return ((differenceInMinutes(end, start) - lunchDuration) / 60).toFixed(2)
  }

  return {
    calcTotalHours
  }
}

export default shifts
